var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('ui-icon',{staticClass:"ml",attrs:{"name":"loading"}}):(_vm.editing)?_c('ui-icon',{staticClass:"ml",attrs:{"name":"edit"}}):(_vm.vDone)?_c('ui-icon',{staticClass:"ml",attrs:{"name":"check"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }